import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { apiGet } from "../../lib/api";

export function SystemAbuseDashboardPage() {
  const [range, setRange] = useState<"24h" | "7d" | "30d">("24h");
  const [groupBy, setGroupBy] = useState<"country" | "language" | "action">("country");
  const query = useQuery({
    queryKey: ["sys-abuse-stats", range, groupBy],
    queryFn: () => apiGet<{ signup_attempts: Array<{ key: string; count: number }>; blocked_attempts: Array<{ key: string; count: number }>; tenant_creations: Array<{ key: string; count: number }> }>(`/v3/sys/abuse/stats?range=${range}&group_by=${groupBy}`),
  });

  return (
    <div className="grid gap-4">
      <h1 className="text-2xl font-semibold">Abuse Dashboard</h1>
      <div className="panel p-4 flex flex-wrap gap-2 items-center">
        <select className="input max-w-xs" value={range} onChange={(e) => setRange(e.target.value as any)}>
          <option value="24h">24h</option><option value="7d">7d</option><option value="30d">30d</option>
        </select>
        <select className="input max-w-xs" value={groupBy} onChange={(e) => setGroupBy(e.target.value as any)}>
          <option value="country">country</option><option value="language">language</option><option value="action">action</option>
        </select>
      </div>
      {query.error ? <p className="text-sm text-rose-600">{String(query.error)}</p> : null}
      <div className="grid md:grid-cols-3 gap-4">
        {["signup_attempts", "blocked_attempts", "tenant_creations"].map((section) => (
          <section key={section} className="panel p-4">
            <h2 className="text-lg font-semibold">{section.replace(/_/g, " ")}</h2>
            <div className="mt-2 grid gap-2 text-sm">
              {(query.data?.[section as keyof typeof query.data] as Array<{ key: string; count: number }> | undefined)?.map((row) => (
                <div key={`${section}-${row.key}`} className="flex justify-between gap-2 border-b border-slate-100 pb-1">
                  <span>{row.key}</span><strong>{row.count}</strong>
                </div>
              )) ?? <p className="text-slate-500">No data</p>}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
